<template>
  <div class="edit-manual-order">
    <h3>Edit Manual Order</h3>

    <p>{{ datapass.unitID }}</p>
    
    <form @submit.prevent="updateOrder">

      <div class="form-group">
        <label>Current Price:</label>
        <input type="number" v-model="formData.currentPrice" required step="0.01" min="0" />
      </div>

      <div class="form-group">
        <label>Current Quantity:</label>
        <input type="number" v-model="formData.currentQty" required step="0.00001" min="0" />
      </div>

      <button type="submit" class="button-success">Update Order</button>
      <button type="button" @click="deleteOrder" class="button-danger" style="margin-left: 10px;">Delete Order</button>
    </form>
  </div>
</template>

<script>
import { inject } from 'vue';

export default {
  name: 'editManualOrderForm',
  props: {
    datapass: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      formData: {
        currentPrice: 0,
        currentQty: 0
      }
    };
  },
  mounted() {
    // ✅ Pré-popula o formulário com os dados recebidos
    if (this.datapass?.current) {
      this.formData.currentPrice = this.datapass.current?.avgPrice || 0;
      this.formData.currentQty = this.datapass.current?.qty || 0;
    }
  },
  setup() {
    const closeModal = inject('closeModal');

    return { closeModal };
  },
  methods: {
    updateOrder() {
      const req = {
        type: 'editManualUnit',
        orderData: {
            unitID: this.datapass.unitID,
            newQty: this.formData.currentQty,
            newPrice: this.formData.currentPrice
        }
      };

      console.log('Update request:', req);
      this.$store.state.socket.send(JSON.stringify(req));
      
      // Fecha o modal após enviar
      this.closeModal(0);
    },
    deleteOrder() {
      if (confirm(`Tem certeza que deseja excluir a ordem ${this.datapass.unitID}?`)) {
        const req = {
          type: 'deleteManualOrder',
          unitID: this.datapass.unitID
        };

        console.log('Delete request:', req);
        this.$store.state.socket.send(JSON.stringify(req));
        
        // Fecha o modal após enviar
        this.closeModal(0);
      }
    }
  }
}
</script>

<style scoped>
.edit-manual-order {
  width: 500px;
  padding: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
}

.form-group input:disabled {
  background-color: #e0e0e0;
  color: #666;
  cursor: not-allowed;
}
</style>